export default __webpack_public_path__ + "static/media/play.2143f322.svg";